import { Fragment, useEffect, useRef, useState } from "react";
import InfiniteScrollGrid from "../../../UI/infinite-scroll-grid";
import {
  ImageNameCellRenderer,
  MoreOptionsRenderer,
  NameCellRenderer,
  RowSelectionRenderer,
} from "../../../UI/grid-cells";
import userImage from "../../../../assets/images/card-grdi-default.png";
function UserManagementGrid({
  selectedColumns,
  rowSelection,
  moreOptions,
  handleNavigate,
  handleEdit,
  handleDelete,
  rowData,
  scrollGroundRef,
  handleScroll,
  initialLoading,
  isLoading,
  limit,
  finalFetch,
  sorting,
  sortingColumnName,
  handleSort,
  handleCheckboxChange,
  noDataFound,
}: any) {
  const [profileImage, setProfileImage] = useState(userImage);
  const handleImageError = () => {
    setProfileImage(userImage);
  };
  const [columnDefs, setColumnDefs] = useState<any>([
    {
      headerName: "Name",
      token: "web.master.label.name",
      field: "firstName",
      width: "flex-1",
      align: "left",
    },
    {
      headerName: "Email",
      token: "web.login.text.email",
      field: "email",
      width: "flex-1",
      align: "left",
    },
    {
      headerName: "Role",
      token: "web.profile.label.role",
      field: "roleName",
      width: "flex-1",
      align: "left",
    },
    {
      headerName: "Phone Number",
      token: "web.profile.label.mobile",
      field: "mobile",
      width: "flex-1",
      align: "left",
    },
    {
      headerName: "Created Date",
      token: "web.common.label.createddate",
      field: "createdAt",
      width: "flex-1",
      align: "left",
    },
  ]);

  const selectedMoreOption = (option: string, row: any) => {
    if (option === "edit") {
      handleEdit(row);
    } else if (option === "delete") {
      handleDelete(row);
    }
  };

  return (
    <div className="w-full h-full">
      <InfiniteScrollGrid
        columnDefs={columnDefs}
        rowData={rowData}
        initialLoading={initialLoading}
        searchedQuery=""
        handleScroll={handleScroll}
        chatGroundRef={scrollGroundRef}
        selectedColumns={selectedColumns}
        isLoading={isLoading}
        finalFetch={finalFetch}
        rowSelection={rowSelection}
        moreOptions={moreOptions}
        handleSort={handleSort}
        sorting={sorting}
        sortingColumnName={sortingColumnName}
        noDataFound={noDataFound}
      >
        {rowData?.map((rowData: any, i: number) => (
          <Fragment key={i}>
            <tr className="w-full h-auto flex justify-between p-[0.65rem] border-b border-[#EDEDED] hover:bg-[#eff8ff] dark:hover:bg-[#112A46]">
              {/* <RowSelectionRenderer
                rowData={rowData}
                rowSelection={rowSelection}
                handleCheckboxChange={handleCheckboxChange}
              /> */}
              <ImageNameCellRenderer
                cellKey="firstName"
                selectedColumns={selectedColumns}
                rowData={rowData}
                handleClick={handleNavigate}
                actionType="user"
              />
              <NameCellRenderer
                cellKey="email"
                selectedColumns={selectedColumns}
                rowData={rowData}
                handleClick={handleNavigate}
              />
              <NameCellRenderer
                cellKey="roleName"
                selectedColumns={selectedColumns}
                rowData={rowData}
                handleClick={handleNavigate}
              />
              <NameCellRenderer
                cellKey="mobile"
                selectedColumns={selectedColumns}
                rowData={rowData}
                handleClick={handleNavigate}
              />
              <NameCellRenderer
                cellKey="createdAt"
                selectedColumns={selectedColumns}
                rowData={rowData}
                handleClick={handleNavigate}
              />
              <MoreOptionsRenderer
                rowData={rowData}
                moreOptions={moreOptions}
                selectedMoreOption={selectedMoreOption}
              />
            </tr>
          </Fragment>
        ))}
      </InfiniteScrollGrid>
    </div>
  );
}
export default UserManagementGrid;
